module.exports = __webpack_public_path__ + "img/14.0aa82589.png";